var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.573,
    height: 17.557,
    viewBox: "0 0 17.573 17.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "edit_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M147.711-801.3h1.282l9.6-9.6-1.282-1.282-9.6,9.6Zm14.209-10.725-3.5-3.468,1.352-1.352a1.512,1.512,0,0,1,1.111-.457,1.512,1.512,0,0,1,1.111.457l1.262,1.262a1.552,1.552,0,0,1,.473,1.095,1.439,1.439,0,0,1-.441,1.095Zm-1.125,1.141-11.14,11.14h-3.5v-3.5l11.14-11.14Zm-2.847-.662-.636-.636,1.282,1.282Z",
    transform: "translate(-146.156 817.305)",
    fill: "#014fe0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/edit_icon_blue.f11927f0cda8d5e95ff93fa9410e0411.svg";
export { ForwardRef as ReactComponent };